<lms-modal #modalVisualizer class="modal-customization-visualizer">
  <div *ngIf="customization">
    <div class="gl-popup__title">
      {{ customization.clientName }} - {{ 'nouns.customization' | translate }}: {{ customization.name }}
    </div>
    <div class="gl-popup__close" (click)="popupClose()">
      <span class="glicon-close"></span>
    </div>
  </div>

  <div class="turnsList" *ngIf="customization">
    <div class="gl-popup__text">
      <b>{{ 'nouns.turns' | translate }} : </b>
    </div>
    <span
      *ngFor="let turnContent of customization.content"
      (click)="selectTurn(turnContent.turn)"
      [ngClass]="{ active: selectedTurn && selectedTurn.turn === turnContent.turn }"
    >
      {{ turnContent.turn }}
    </span>
    <div *ngIf="selectedTurn && !showTest">
      <gl-button
        color-primary
        text="{{ 'actions.watchTest' | translate }} {{ selectedTurn.turn }}"
        (onClick)="toggleTest()"
        class="margin-left"
      ></gl-button>
    </div>
  </div>

  <div *ngIf="selectedDocument && !showTest" class="visor-neutro-large">
    <h1 class="text-centered text-big-height display-none">{{ selectedDocument.name }}</h1>
    <div class="message-previsualizer">{{ 'nouns.messagePrevisualizer' | translate }}</div>
    <iframe id="iframeDocument"></iframe>
    <div class="text-centered text-big-height">
      <span (click)="prev()" class="btn-nav">
        <i class="glicon-left-arrow"></i>
      </span>
      <span>{{ indexDocument + 1 }} / {{ selectedTurn.documents.length }}</span>
      <span (click)="next()" class="btn-nav">
        <i class="glicon-right-arrow"></i>
      </span>
    </div>
  </div>

  <div *ngIf="showTest" class="visor-hacker padding-10">
    <div class="test-body">
      <div *ngFor="let question of test; let i = index" class="margin-bottom">
        <div class="question-color">{{ i + 1 }}. - {{ question.question }}</div>
        <div *ngFor="let answer of question.answers" [ngClass]="answer.isCorrect ? 'correct-color' : 'answer-color'">
          <span class="margin-left"> {{ answer.title }} </span>
          <span *ngIf="answer.isCorrect" class="glicon-checkmark"></span>
        </div>
      </div>
    </div>
    <gl-button icon icon-center="glicon-left-arrow" (onClick)="toggleTest()" class="left"></gl-button>
  </div>
</lms-modal>
